import { createFileRoute } from "@tanstack/react-router";

import CreateEntrySidebar from "@/components/CompetitionEntries/CreateEntrySidebar";

export const Route = createFileRoute("/gym/$venueUuid/events/$competitionUuid/competitors/create")({
  component: CreateEntrySidebar,
});
